/**
 * @fileoverview Constantes y parámetros de configuración para la consolidación de mensajes del agente.
 * @module consolidationConstants
 * @category Constants - Inbox
 */

export const DEFAULT_CONSOLIDATION_TIME_SECONDS = Number(ENV['DEFAULT_CONSOLIDATION_TIME_SECONDS']) || 10;
export const TARGET_CHAR_LIMIT = 200; // Límite objetivo ideal para legibilidad móvil (~30-35 palabras)
export const INTELLIGENT_MAX_CHAR_LIMIT = 220; // Límite máximo antes de cortar para evitar bloques masivos de texto
export const SHORT_PHRASE_MAX_CHAR_THRESHOLD = 80; // Umbral estándar de micro-frase (~10-12 palabras).

// Umbrales adaptativos de inactividad de tipeo según investigaciones de interacción humana (HCI Chat Behavior)
export const HUMAN_TYPING_PAUSE_THRESHOLD_MS = 3500; // 3.5s de silencio de tipeo = el agente terminó su idea
export const TERMINAL_PUNCTUATION_PAUSE_MS = 2500;   // 2.5s si incluye signos terminales de conclusión (. ! ?)
export const CLOSING_PHRASE_PAUSE_MS = 1500;          // 1.5s si es fórmula clara de despedida o cierre de atención
